module.exports = "\n<div class=\"movie\" id=\"wrapper\">\n  <div id=\"introchart\"></div>\n</div>\n"